import React, {useState} from 'react';

import CollapserThing from './CollapserThing';
import {FAQPage} from './LinkedData';

const QuestionAndAnswer = ({item}) => {
  const [open, setOpen] = useState(false);
  const contentId = `faq-answer-${item.question?.toString().replace(/\s+/g, '-').toLowerCase()}`;

  return (
    <>
      <button
        className="px-8 flex items-center justify-between w-full h-20 border-t border-gray-100 font-heading text-base font-medium text-gray-800 cursor-pointer text-left"
        onClick={() => setOpen(!open)}
        type="button"
        aria-expanded={open}
        aria-controls={contentId}
      >
        {item.question}
        <svg
          aria-hidden="true"
          className={`w-2 h-2 shrink-0 ml-4 transition-transform duration-300 ${open ? 'rotate-90' : ''}`}
          viewBox="0 0 9 11"
          fill="#646464"
        >
          <polygon points="9 5.5 0 11 0 0" />
        </svg>
      </button>
      <CollapserThing visible={open}>
        <div id={contentId} className="px-8 py-5 bg-gray-50 text-[15px] text-left">
          {item.answer}
        </div>
      </CollapserThing>
    </>
  );
};

const FAQs = ({items = [], includeMetadata = false}) => (
  <div className="bg-white shadow-lg rounded-md mx-auto my-5 mb-12 overflow-hidden max-w-[1000px]">
    {includeMetadata && <FAQPage items={items} />}
    {items.map((item) => (
      <QuestionAndAnswer item={item} key={item.question} />
    ))}
  </div>
);

export default FAQs;
